import { createFileRoute } from "@tanstack/react-router"
import { GridList, GridListItem } from "react-aria-components"
import { useTranslation } from "react-i18next"

import Card from "@/globalComponents/atoms/Card"
import Heading from "@/globalComponents/atoms/Heading"
import Icon from "@/globalComponents/atoms/Icon"
import Text from "@/globalComponents/atoms/Text"
import {
  getLanguageName,
  iconForLanguage,
  SUPPORTED_LANGUAGES,
} from "@/utilities/localization"

import styles from "./language.module.css"

export const Route = createFileRoute("/settings/language")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t, i18n } = useTranslation()
  return (
    <>
      <Card>
        <Heading level={1}>{t("settings.changeLanguage.header")}</Heading>
        <Text level={2} style={{ marginTop: "var(--space-2)" }}>
          {t("settings.changeLanguage.description")}
        </Text>
        <GridList
          aria-label={t("settings.changeLanguage.label")}
          selectionMode="single"
          selectedKeys={i18n.resolvedLanguage ? [i18n.resolvedLanguage] : []}
          disallowEmptySelection
          onSelectionChange={(keys) =>
            i18n.changeLanguage([...keys][0].toString())
          }
        >
          {SUPPORTED_LANGUAGES.map((l) => (
            <GridListItem
              key={l}
              id={l}
              className={styles.languageListItem}
              textValue={getLanguageName(l)}
            >
              {({ isSelected }) => (
                <>
                  <div className={styles.flagContainer}>
                    <Icon
                      name={iconForLanguage(l)}
                      retainOriginalColors={
                        iconForLanguage(i18n.resolvedLanguage) !== "translation"
                      }
                    />
                  </div>
                  <Text className="medium">{getLanguageName(l)}</Text>
                  {isSelected && <Icon name="check" slot="right" />}
                </>
              )}
            </GridListItem>
          ))}
        </GridList>
      </Card>
    </>
  )
}
